module.exports = __webpack_public_path__ + "img/1211819908949985.210f1e38.jpg";